import { render, staticRenderFns } from "./AssetDetailsHeader.vue?vue&type=template&id=143f0877&scoped=true&"
import script from "./AssetDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./AssetDetailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetailsHeader.vue?vue&type=style&index=0&id=143f0877&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f0877",
  null
  
)

export default component.exports